import { forwardRef } from "react";
import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import ControlledServerSideCreatable from "../../Controlled/ControlledSSCreatable";
import { CustomizedBox } from "../../Custom/CustomizedBox";

const CancelDetailForm = forwardRef(
  ({ control, errors, setValue, disabled }, ref) => {
    const { t } = useTranslation();

    const watchPendingCancel = useWatch({
      control,
      name: "pending_cancel",
    });
    return (
      <CustomizedBox ref={ref}>
        <Typography ml={1} mb={2} fontWeight="bold">
          {t("sales.order.cancel_detail")}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <ControlledServerSideCreatable
              name="sale_cancel_remark"
              documentType="order"
              title={t("sales.order.sales_and_service")}
              defaultOptions={[]}
              control={control}
              error={Boolean(errors?.sale_cancel_remark)}
              helperText={
                errors?.sale_cancel_remark && errors?.sale_cancel_remark.message
              }
              setValue={setValue}
              viewOnly={!watchPendingCancel && disabled}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <ControlledServerSideCreatable
              name="delivery_cancel_remark"
              documentType="order"
              title={t("sales.order.quality_and_logistic")}
              defaultOptions={[]}
              control={control}
              error={Boolean(errors?.delivery_cancel_remark)}
              helperText={
                errors?.delivery_cancel_remark &&
                errors?.delivery_cancel_remark.message
              }
              setValue={setValue}
              viewOnly={!watchPendingCancel && disabled}
            />
          </Grid>
        </Grid>
      </CustomizedBox>
    );
  }
);

export default CancelDetailForm;
